<template>
  <div :class="{ 'text-right': isRight }" class="mt-4 message">
    <b-row v-if="isRight">
      <b-col class="pr-2">
        <b-skeleton class="rounded-lg right" width="600px" height="80px" />
      </b-col>

      <b-col cols="1" class="pl-0">
        <b-skeleton-img width="40px" height="40px" class="rounded-circle d-block ml-auto mr-auto" />
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col cols="1" class="pr-0">
        <b-skeleton-img width="40px" height="40px" class="rounded-circle d-block ml-auto mr-auto" />
      </b-col>

      <b-col class="pl-2">
        <div class="message__bubble">
          <b-skeleton class="rounded-lg" width="600px" height="80px" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSkeleton, BSkeletonImg } from "bootstrap-vue";

export default {
  name: "Message",
  components: { BRow, BCol, BSkeleton, BSkeletonImg },
  props: {
    isRight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.right {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 0;
}

.message {
  .message__bubble {
    max-width: 600px;
  }
}
</style>
